import {useSelector} from 'react-redux'
import {useGetComposedOfferCheckAPIParamsBuilder} from 'hooks/roomOfferInteraction/useGetComposedOfferCheckAPIParams'

import {offerCheckApi} from '@daedalus/core/src/offer/services/offerCheckApi'
import {Offer} from '@daedalus/core/src/offer/types/offer'
import {SplitBooking} from '@daedalus/core/src/room/types/room'
export const useGetIsOfferSoldOut = ({
  offer,
  splitBooking
}: {
  offer?: Offer
  splitBooking?: SplitBooking
}) => {
  const {buildOfferCheckParams} = useGetComposedOfferCheckAPIParamsBuilder()

  const apiParams = buildOfferCheckParams({offer, splitBooking})

  const {isError} = useSelector(
    offerCheckApi.endpoints.getOfferCheck.select(apiParams)
  )

  return isError
}
